import { Injectable } from '@angular/core';
import {BonusDiscreta} from '../../../models/bonusDiscreta';
import { BonusDiscretaGuest } from 'src/app/models/VwLabBonusDiscretaGuest';

@Injectable({
  providedIn: 'root'
})
export class BonusDiscretaStore {
  title = 'Bonus Discreta';
  viewAllPath = '/menu/viewall/bonusDiscreta';
  showLoader: boolean;

  records: BonusDiscreta[];
  sortedRecords: BonusDiscreta[];
  totalRecords: number;

//  isGuest: boolean=true;
  recordsGuest: BonusDiscretaGuest[];
  sortedRecordsGuest: BonusDiscretaGuest[];
  

  constructor() {
    this.records = [];
    this.sortedRecords = [];
  }

  load(records: BonusDiscreta[]) {
    // TODO: sorting here
    this.records = records;
    this.sortedRecords = this.records.slice();
  }

  loadGuest(records: BonusDiscretaGuest[]) {
    this.recordsGuest = records;
    this.sortedRecordsGuest = this.recordsGuest.slice();
  }

}

